export const isConfigEnabled = (value: unknown) =>
  value === true || value === "true" || value === 1 || value === "1";

export type FormBypassStartMode = "intro" | "chat" | "chat_only";

// chat: skip intro, open text chat (voice toggle allowed); chat_only: skip intro, text only.
export const getFormBypassStartMode = (
  configs: Record<string, unknown> | null | undefined,
  isFormBypassUI: boolean,
  isChatbotEnabled: boolean,
): FormBypassStartMode => {
  if (!isFormBypassUI || !isChatbotEnabled) return "intro";
  if (isConfigEnabled(configs?.form_bypass_chat_only)) return "chat_only";
  if (isConfigEnabled(configs?.form_bypass_direct_chat)) return "chat";
  return "intro";
};
